<template>
  <div>
    <div v-show="activitiesLoading">
      <v-row class="mt-5" justify="center" align="center">
        <v-progress-circular indeterminate color="primary"/>
      </v-row>
    </div>
    <div v-show="!activitiesLoading" :id="`contract-detail-activities-${contractMode}`">
      <EntityActivityTable
        :showActions="showActions"
        :contract="contract"
        :tract="tract"
        :selectedDate="selectedDate"
        :allActivities="allActivities"
        :loading="activitiesLoading"
        :multiEntity="false"
        :tableHeightCalculationData="{ auto: true }"
        @refresh="$emit('refresh-activities')"
        @table-event="tableEvent"
        @new-detail="$emit('refresh-activities')"
        @scheduled-rate-change-clicked="onScheduledRateChangeIconClicked"
      />
    </div>
    <NoData v-if="allActivities.length === 0 && !activitiesLoading">{{ $t('noActivitiesPuncuated') }}</NoData>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { contractModeFor, cssViewHeightForDialogWithFullscreenState } from '@/utils/componentHelpers'
import { kebabCase } from 'lodash'

export default {
  name: 'ContractDetailActivities',
  components: {
    EntityActivityTable: () => import('@/components/activity/EntityActivityTable.vue'),
    NoData: () => import('@/components/core/NoData.vue')
  },

  props: {
    contract: {
      type: Object,
      default: undefined,
      required: true
    },
    showActions: {
      type: Boolean,
      default: true,
      required: false
    },
    allActivities: {
      type: Array,
      default: undefined,
      required: true
    },
    tract: {
      type: Object,
      default: undefined
    },
    selectedDate: {
      type: String,
      default: null
    }
  },

  data: () => ({
    products: []
  }),

  computed: {
    ...mapGetters('activity', ['activitiesLoading']),
    ...mapGetters('dialog', ['topDialogState']),

    contractMode () {
      return kebabCase(contractModeFor(this.contract.type).label)
    },

    tableHeight () {
      return `min(500px, max(256px, calc(${cssViewHeightForDialogWithFullscreenState(this.topDialogState.fullscreen)} - 530px)))`
    }
  },

  methods: {
    ...mapActions('scheduled-rate-change', ['fetchScheduledRateChanges']),

    tableEvent (event) {
      this.$emit('table-event', event)
    },

    onScheduledRateChangeIconClicked () {
      this.$emit('scheduled-rate-change-clicked')
    }
  }
}
</script>
